import api from './api_client';

export const rankingService = {
  analyzeCV: async (applicationId) => {
    const response = await api.post(`/ai/analyze-cv/${applicationId}`);
    return response.data;
  },

  analyzeCVText: async (cvText, requiredSkills = []) => {
    const response = await api.post('/ai/analyze-cv-text', {
      cv_text: cvText,
      required_skills: requiredSkills
    });
    return response.data;
  },

  getRanking: async (jobOfferId) => {
    const response = await api.get(`/ai/ranking/${jobOfferId}`);
    return response.data;
  },

  getApplicationAnalysis: async (applicationId) => {
    const response = await api.get(`/ai/application-analysis/${applicationId}`);
    return response.data;
  },

  deleteApplicationAnalysis: async (applicationId) => {
    const response = await api.delete(`/ai/application-analysis/${applicationId}`);
    return response.data;
  },

  getDashboardData: async () => {
    const response = await api.get('/ai/dashboard');
    return response.data;
  }
};

export default rankingService;
